// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ckiP","questions":"styles_questions__1qN_j","footer":"styles_footer__1UMl7"};